// 工单报表总页面

import React, { Component } from "react";
import { Progress, Tooltip, Popover, Tabs } from "antd";
import { queryTicketNumByDim } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import FormCore from "@/components/display/form/formCore";
import moment from "moment";
import PropTypes from "prop-types";
import PeopleCountModel from "@/pages/displayBoard/peopleCountModel";
// css
import "@/assets/stylus/displayBoard.styl";
// icon
import { QuestionCircleFilled, QuestionCircleOutlined } from "@ant-design/icons";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
const TabPane = Tabs.TabPane;
@connect((state) => state)
class TicketCountPage extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;

    this.state = {
      pieData:[],
      pType:1,
      barData:[],
      num11:0,
      num12:0,
      num13:0,
      num14:0,
      num15:0,
      totalNum:0,
      totalHour:0,
      peopleData:[],
      areaList:[
            {
              text: "全部",
              value: "",
            }],
      param: {
        cityIds: "",
        provinceIds: "000000", // 默认 000000全国
        date: '',
        operationProperty: "3",
        
      },
      equipmentQry: {
        station: 0, // 桩群数量
        powerBox: 0, // 配电柜数量
        stub: 0, // 桩数量
      },
      successRate: "0",
      stubIntactRate: "0",
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  // 页面加载前方法
  componentWillMount() {
    this.setState({
      formConfig: this.initForm(),
    });
    this.getEquipmentQry(5);
    this.getEquipmentQry(1);

  }

  // 页面加载完成方法
  componentDidMount() {}

  /**
   * 获取充电成功率数字
   */
  getSuccessRate = (value) => {
    this.setState({
      successRate: value,
    });
  };

  /**
   * 获取设备完好率数字
   */
  getStubIntactRate = (value) => {
    
    this.setState({
      stubIntactRate: value,
    });
  };


  /**
   * 获取人效指标数据
   */
  getEquipmentQry(dim) {
    var date = this.state.param.date;
    if (date === '')
    {
      date =  [moment(new Date()).subtract(7, "d").format("YYYY-MM-DD"), moment(new Date()).subtract(1, "d").format("YYYY-MM-DD")];
    } else {
      date = date.split(",");
    }
    
    fetchHandler(queryTicketNumByDim, {
      startTime: date[0],
      endTime:date[1],
      dimType:dim,
      operationProperty: "3",
    }).then((res) => {
      if (res.data) {
        //按照工单等级进行分组合并，用于饼图、柱状图和下面的人员数据展示  后台返回的是列表数据，列表是根据人员和工单类型分组的。
        
        
        if (dim == 5)
        {
          var totalNum = 0;
          var totalNum = 0;
          var totalHour = 0;
          var num11 = 0;
          var num12 = 0;
          var num13 = 0;
          var num14 = 0;
          var num15 = 0;
          //11-故障工单 12-巡检工单 13-调试工单 14-验收工单 15-通用工单 
          for (let i in res.data)
          {
            totalNum += res.data[i].totalNum;
            totalHour += res.data[i].totalHour;
            if (res.data[i].ticketType === 11)
            {
              num11 += res.data[i].totalNum;
            } else if (res.data[i].ticketType === 12)
            {
              num12 = res.data[i].totalNum;
            }  else if (res.data[i].ticketType === 13)
            {
              num13 = res.data[i].totalNum;
            }  else if (res.data[i].ticketType === 14)
            {
              num14 = res.data[i].totalNum;
            }  else if (res.data[i].ticketType === 15)
            {
              num15 = res.data[i].totalNum;
            }  else if (res.data[i].ticketType === 31)
            {
              num11 += res.data[i].totalNum;
            } 
          }
          this.setState({
            num11:num11,
            totalHour:totalHour,
            num12:num12,
            totalNum:totalNum,
            num13:num13,
            num14:num14,
            num15:num15,
          });

        } else {
          this.setState({
            oneData:{data:res.data, pType:dim},
          });
        }
      }
    });
  }


  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.setState({
      pType:param
    })
    this.getEquipmentQry(param);
  };

  // 加载form方法
  initForm() {
    const formConfig = {
      childItems: [
        {
          type: "date",
          dateType: "rangeDate",
          placeholder: [
            '开始时间',
            '结束时间',
          ],
          param: {
            name: "date",
            type: "array",
          },
          width: "200px",
          allowClear: false,
          defaultValue:
            this.state.param.date === ""
              ? [moment(new Date()).subtract(7, "d"), moment(new Date()).subtract(1, "d")]
              : [moment(this.state.param.date).subtract(7, "d"), moment(this.state.param.date)],
          validator: {
            // 日期自定义校验规则
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            max_val: 31, // 最大可选天数
          }, // 自定义校验规则
          labelName: '时间范围', // '订单结束时间:',
          required: !1,
        },
        
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              text: "查询",
              // icon: "search",
              handler: (e, param) => {
                
                this.setState(
                  {
                    param: {
                      date: param.date,
                      operationProperty: "3",
                    },
                  },
                  () => {
                    // 查询设备数据
                    this.getEquipmentQry(5);
                    this.getEquipmentQry(this.state.pType);
                  },
                );
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        operationProperty: "3",
      },
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "oprationLogTable",
    };

    return formConfig;
  }

  // style={{ "min-width": "1440px" }}
  render() {
    const content = (
      <div className='sc-page-content display-board-page'>
        <div className='page-toolbar'>
          <FormCore formConfig={this.state.formConfig} />
        </div>
        <div className='page-panel'>
          <div className='display-board'>
          <div className='item daochu'>
              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                      工单总数{" "}
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>电站为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.totalNum}</div>
                  </div>
                </div>
              </div>
              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                      调试工单总数
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>配电柜为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.num13}</div>
                  </div>
                </div>
              </div>
              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                        通用工单总数
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>设备为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.num15}</div>
                  </div>
                </div>
              </div>

              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                        故障工单数量
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>设备为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.num11}</div>
                  </div>
                </div>
              </div>

            </div>
            <div className='item daochu'>

              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                        巡检工单数量
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>设备为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.num12}</div>
                  </div>
                </div>
              </div>

              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                        验收工单数量
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>设备为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.num14}</div>
                  </div>
                </div>
              </div>

              <div className='inner' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                  
                  <div className='stub-info-item'>
                    <div className='name'>
                        工时总数
                      {/* <Tooltip
                        title={() => <span style={{ color: "#000" }}>设备为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip> */}
                    </div>
                    <div className='num'>{this.state.totalHour}</div>
                  </div>
                </div>
              </div>
            </div>
           
            <div className='item daochu' >
              <div className='inner' style={{ minHeight: "621px" }}>


              <Tabs defaultActiveKey="1" onChange={this.openTab}>
              <TabPane tab="人员数据" key="1">
              <div>
                <PeopleCountModel param={this.state.oneData} />
                </div>
              </TabPane>
              <TabPane tab="电站数据" key="2">
              <div>
                <PeopleCountModel param={this.state.oneData} />
                </div>
              </TabPane>
              <TabPane tab="设备数据" key="3">
              <div>
                <PeopleCountModel param={this.state.oneData} />
                </div>
              </TabPane>
              <TabPane tab="故障数据" key="4">
              <div>
                <PeopleCountModel param={this.state.oneData} />
                </div>
              </TabPane>
            </Tabs>
                
                
              </div>
            </div>

          </div>
        </div>
      </div>
    );
    return content;
  }
}

export default injectIntl(TicketCountPage);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/ticketCountPage.js